import type { TFunction } from 'i18next';
import type {
  PurchaseOrderActivityDetailState,
  PurchaseOrderActivityItem,
  PurchaseOrderActivityLineChange,
} from '../types/purchase-order-activity-item';

type PurchaseOrderActivityLineSyncedProps = {
  activity: PurchaseOrderActivityItem;
  onOpenDetail: (detail: PurchaseOrderActivityDetailState) => void;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityLineSynced({
  activity,
  onOpenDetail,
  t,
}: PurchaseOrderActivityLineSyncedProps) {
  const rows = activity.metadata?.values ?? [];
  const count = activity.metadata?.changedLinesCount;

  return (
    <>
      <span className='font-semibold'>
        {t('activity.line.synced', { count })}
      </span>
      <button
        className='cursor-pointer font-medium text-foreground underline underline-offset-2'
        onClick={() =>
          onOpenDetail({
            kind: 'changes',
            title: t('activity.titles.sync'),
            description: t('activity.descriptions.syncedProducts', { count }),
            rows: rows as PurchaseOrderActivityLineChange[],
          })
        }
        type='button'
      >
        {t('activity.actions.viewSync')}
      </button>
    </>
  );
}
